/**
 * RatingScale — 1-5 circular button row used by quick-KM and technology questions.
 * Pure / controlled. Callers pass the selected value as a string ("1".."5") so the
 * answers map stays serialisable.
 */
export const RatingScale = ({ value, onChange, labels }) => (
  <div className="flex items-center gap-1">
    {[1, 2, 3, 4, 5].map((n) => (
      <button
        key={n}
        type="button"
        onClick={() => onChange(String(n))}
        className={`w-9 h-9 rounded-full border-2 text-sm font-medium transition-all ${String(n) === value ? 'bg-[#002FA7] border-[#002FA7] text-white scale-110' : 'border-[#E5E7EB] text-[#4B5563] hover:border-[#002FA7] hover:text-[#002FA7]'}`}
        data-testid={`rating-${n}`}
      >
        {n}
      </button>
    ))}
    {labels && (
      <div className="ml-3 flex gap-3 text-[10px] text-[#9CA3AF]">
        <span>1={labels[0]}</span>
        <span>5={labels[1]}</span>
      </div>
    )}
  </div>
);
